export default __webpack_public_path__ + "static/media/asana-logo.46794337.svg";